import React from "react";
import { AnimatePresence, motion } from "framer-motion";

interface RecoveryOverlayProps {
  level: number; // 0 = off, 1..3
}

// A calm vignette that gently reduces surrounding complexity during recovery.
// No red, no error iconography — just a softening of everything but the anchor.
export const RecoveryOverlay: React.FC<RecoveryOverlayProps> = ({ level }) => {
  const active = level > 0;
  const dim = active ? 0.35 + level * 0.12 : 0;
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          data-testid="recovery-overlay"
          className="pointer-events-none fixed inset-0 z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            background: `radial-gradient(ellipse 70% 55% at 50% 46%, rgba(6,8,11,0) 0%, rgba(6,8,11,${dim}) 78%, rgba(6,8,11,${Math.min(
              0.85,
              dim + 0.25
            )}) 100%)`,
          }}
        />
      )}
    </AnimatePresence>
  );
};
